<app-statistics *ngIf = "canReadStatistics"></app-statistics>
<div *ngIf = "!canReadStatistics" class = "welcome-text">
  Üdvözlünk a Mr. Kresz adminisztációs felületén!
</div>
